(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntitiesListCtrl', EntitiesListCtrl);

    EntitiesListCtrl.$inject = ['$scope', '$q', '$routeParams', 'SystemService', 'DialogService', 'WindowTitleService'];

    function EntitiesListCtrl($scope, $q, $routeParams, SystemService, DialogService, WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.showPanel = showPanel;
        vm.entityLabel = '';

        activate();

        function activate() {
            $scope.$watch('vm.entityLabel', updateTitle);

            var loadPromises = [];
            loadPromises.push(loadListPageSize());

            $q.all(loadPromises).then(function () {
                var dashboardSettingConfiguration = { SearchFields: {} };
                dashboardSettingConfiguration.ListPageSize = vm.ListPageSize;
                dashboardSettingConfiguration.EntityTemplateId = 0;

                if (!angular.isUndefined($routeParams.entityTemplateId) && $routeParams.entityTemplateId !== null) {
                    dashboardSettingConfiguration.EntityTemplateId = $routeParams.entityTemplateId;
                    vm.dashboardSettingConfiguration = angular.copy(dashboardSettingConfiguration);
                } else {
                    vm.error = 'Error: Route parameter entityTemplateId must be supplied.';
                }
            });
        }

        function updateTitle(entityLabel) {
            if (!_.isNil(entityLabel) && entityLabel.length && entityLabel.length > 0) {
                WindowTitleService.setTitle(entityLabel);
            } else {
                WindowTitleService.setTitle();
            }
        }

        function loadListPageSize() {
            return SystemService.getMenuListSize('Entities')
                .then(getListPageSizeOk, getListPageSizeError);
            
            function getListPageSizeOk(data) {
                vm.ListPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        function showPanel() {
            return !_.isNil(vm.dashboardSettingConfiguration) && !vm.error;
        }
    }
})();
